import { render, staticRenderFns } from "./register_step.vue?vue&type=template&id=b7b5b288"
import script from "./register_step.vue?vue&type=script&lang=js"
export * from "./register_step.vue?vue&type=script&lang=js"
import style0 from "./register_step.vue?vue&type=style&index=0&id=b7b5b288&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports